import type { Columns } from "@intility/gjallarbru";
import type { ClientListItem, PlatformListItem } from "../../api/types";
import { ClientTags } from "./ClientTags";

type Row = { row: { original: PlatformListItem } };

// Name, Description and Clients are owned here, so every surface that lists
// platforms (the Platforms page, My Hub) renders them the same way. The
// description column is pinned at 360 px in both the header and the body: a
// stretchable column widens past its header on wide tables, and uncapped text
// otherwise forces the column as wide as the description itself. The full text
// stays available through the tooltip.
export function buildPlatformColumns(
  clientsByPlatform: Map<string, ClientListItem[]>,
  columnsBefore: Columns<PlatformListItem>,
  columnsAfter: Columns<PlatformListItem>,
): Columns<PlatformListItem> {
  return [
    ...columnsBefore,
    {
      accessorKey: "name",
      header: "Name",
      meta: { primaryColumn: true },
    },
    {
      accessorKey: "description",
      Cell: ({ row }: Row) => {
        const description = row.original.description;
        if (!description) return null;
        return (
          <span
            className="bfc-base-2"
            title={description}
            style={{
              display: "block",
              maxWidth: 360,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {description}
          </span>
        );
      },
      // "grow: false" stops the column stretching past its size on wide
      // tables (the same pattern the My Hub favourite star uses).
      grow: false,
      header: "Description",
      size: 360,
    },
    {
      accessorKey: "clientCount",
      Cell: ({ row }: Row) => {
        const platformClients = clientsByPlatform.get(row.original.id);
        return platformClients ? (
          <ClientTags clients={platformClients} />
        ) : null;
      },
      header: "Clients",
    },
    ...columnsAfter,
  ];
}
